import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Title from "../components/title"
import SceneComponent from "../components/scenecomponent"

const AboutPage = () => (
  <Layout>
    <SEO title="About" />
    <Title title="3D Rendering" />
    <div style={{ margin: `3rem auto`, maxWidth: 600 }}>
      Oh oh oh; you're my cover girl.
    </div>
    <SceneComponent />
    <Link to="/">Go back to the homepage</Link>
  </Layout>
)

export default AboutPage
